// eslint-disable-next-line no-restricted-exports, no-restricted-imports
export { default } from "./hyview/flavor.config";
